import {
  validateProfileFieldValueClient,
  deserializeProfileFieldValueForForm,
} from './constants';

/** Shared display/validation state for profile field grid rows (web + mobile). */
export function getProfileFieldRowState(
  field,
  rawValue,
  formSubmitted,
  fieldErrors,
  errorKey,
) {
  const displayValue = deserializeProfileFieldValueForForm(field, rawValue);
  const helperText =
    fieldErrors?.[errorKey] ||
    (formSubmitted
      ? validateProfileFieldValueClient(field, displayValue)
      : '');
  return {
    displayValue,
    helperText,
    hasError: Boolean(helperText),
  };
}
